// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-visualization-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.data-visualization-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.data-visualization-main-card {
  max-width: 100%;
}

.data-visualization-title-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.data-visualization-logo {
  height: 48px;
  width: auto;
  margin: 24px 0;
}

.data-visualization-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.data-visualization-section {
  width: 100%;
}

.data-visualization-section-card {
  height: 100%;
}

.data-visualization-section-card .ant-card-head-title {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/DataVisualization.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".data-visualization-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.data-visualization-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.data-visualization-main-card {\n  max-width: 100%;\n}\n\n.data-visualization-title-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.data-visualization-logo {\n  height: 48px;\n  width: auto;\n  margin: 24px 0;\n}\n\n.data-visualization-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.data-visualization-section {\n  width: 100%;\n}\n\n.data-visualization-section-card {\n  height: 100%;\n}\n\n.data-visualization-section-card .ant-card-head-title {\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
